(function () {
  'use strict';

  var root = document.documentElement;
  if (window.Shopify && window.Shopify.designMode) root.classList.add('shopify-design-mode');

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Sticky header shadow ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Drawers & modals ---------- */
  var lastFocus = null;

  function focusables(el) {
    return $$('button, [href], input:not([type="hidden"]), select, textarea', el).filter(function (f) {
      return !f.disabled && f.offsetParent !== null;
    });
  }

  function openLayer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var focusable = el.querySelector('[autofocus]') || focusables(el)[0];
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }

  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .modal.is-open, .search-modal.is-open')) document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openLayer(document.getElementById(opener.dataset.drawerOpen)); return; }

    var closer = t.closest('[data-drawer-close]');
    if (closer) { closeLayer(closer.closest('[data-drawer]')); return; }

    var modalOpen = t.closest('[data-modal-open]');
    if (modalOpen) { e.preventDefault(); openLayer(document.getElementById(modalOpen.dataset.modalOpen)); return; }

    if (t.matches('[data-modal]') || t.closest('[data-modal-close]')) { closeLayer(t.closest('[data-modal]')); return; }

    if (t.closest('[data-search-open]')) { openLayer($('[data-search-modal]')); return; }
    if (t.matches('[data-search-modal]') || t.closest('[data-search-close]')) { closeLayer($('[data-search-modal]')); return; }

    var cartOpen = t.closest('[data-cart-open]');
    if (cartOpen && $('[data-cart-drawer]') && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openLayer($('[data-cart-drawer]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      var layer = $('.drawer.is-open, .modal.is-open, .search-modal.is-open');
      var items = layer ? focusables(layer) : [];
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      return;
    }
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open, .modal.is-open, .search-modal.is-open').forEach(closeLayer);
  });

  /* ---------- Launch countdown ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var target = Date.parse(el.dataset.countdown);
    if (isNaN(target)) return;
    var days = Math.ceil((target - Date.now()) / 86400000);
    if (days <= 0) return;
    el.textContent = days === 1 ? '1 day to go' : days + ' days to go';
    el.hidden = false;
  });

  /* ---------- Sign-up slide-in ---------- */
  var slidein = $('[data-slidein]');
  if (slidein) {
    var store = {
      get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
    };
    var KEY = 'gg-slidein';
    var justPosted = /customer_posted=true/.test(window.location.search) && window.location.hash === '#SlideinSignup';
    var hideAfter = Date.parse(slidein.dataset.hideAfter || '');
    var expired = !isNaN(hideAfter) && Date.now() > hideAfter;

    var showSlidein = function () {
      if (slidein.classList.contains('is-open') || $('.drawer.is-open, .modal.is-open, .search-modal.is-open')) return;
      var count = $('[data-cart-count]');
      if (count && count.textContent.trim() !== '') return;
      slidein.classList.add('is-open');
      slidein.setAttribute('aria-hidden', 'false');
      store.set(KEY, 'seen');
      cleanup();
    };
    var hideSlidein = function () {
      slidein.classList.remove('is-open');
      slidein.setAttribute('aria-hidden', 'true');
    };
    var onScroll = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max * 100 >= parseInt(slidein.dataset.scroll || '50', 10)) showSlidein();
    };
    var timer = null;
    var cleanup = function () { clearTimeout(timer); window.removeEventListener('scroll', onScroll); };

    if (justPosted) {
      // Show the success message in place after the form reloads the page.
      store.set(KEY, 'subscribed');
      slidein.classList.add('is-open');
      slidein.setAttribute('aria-hidden', 'false');
    } else if (!store.get(KEY) && !expired && !(window.Shopify && window.Shopify.designMode)) {
      timer = setTimeout(showSlidein, parseInt(slidein.dataset.delay || '15', 10) * 1000);
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    slidein.addEventListener('click', function (e) { if (e.target.closest('[data-slidein-close]')) hideSlidein(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideSlidein(); });
  }
  // Theme editor: preview the slide-in while its section is selected.
  document.addEventListener('shopify:section:select', function (e) {
    var el = e.target.querySelector('[data-slidein]');
    if (el) { el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var el = e.target.querySelector('[data-slidein]');
    if (el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); }
  });

  /* ---------- Cart ---------- */
  var cartType = document.body.dataset.cartType || 'drawer';

  function cartSections() {
    var ids = ['cart-drawer'];
    if ($('[data-cart-page]')) ids.push(getCartPageSectionId());
    return ids.filter(Boolean);
  }

  function getCartPageSectionId() {
    var el = $('[data-cart-page]');
    var section = el && el.closest('.shopify-section');
    return section ? section.id.replace('shopify-section-', '') : null;
  }

  function renderSections(sections) {
    if (!sections) return;
    // Remember which cart control had focus so it survives the re-render.
    var active = document.activeElement;
    var activeItem = active && active.closest('.cart-item');
    var line = activeItem && activeItem.dataset.line;
    var pos = activeItem ? $$('button, input', activeItem).indexOf(active) : -1;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var current = document.getElementById('shopify-section-' + id);
      if (!current) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('shopify-section-' + id);
      if (!fresh) return;
      var wasOpen = current.querySelector('.drawer.is-open');
      current.innerHTML = fresh.innerHTML;
      if (wasOpen) {
        var drawer = current.querySelector('[data-drawer]');
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
      }
    });
    if (activeItem) {
      var scope = $('.drawer.is-open') || $('[data-cart-page]') || document;
      var item = $('.cart-item[data-line="' + line + '"]', scope) || $('.cart-item', scope);
      var target = item ? $$('button, input', item)[Math.max(pos, 0)] : $('[data-drawer-close]', scope);
      if (target) target.focus();
    }
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; });
  }

  function refreshCount() {
    return fetch(window.theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); return cart; });
  }

  function changeLine(line, quantity) {
    var body = $('[data-cart-drawer] .drawer__panel') || $('[data-cart-page]');
    if (body) body.classList.add('is-loading');
    return fetch(window.theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: cartSections() })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderSections(cart.sections);
        updateCount(cart.item_count);
      })
      .finally(function () {
        var b = $('[data-cart-drawer] .drawer__panel') || $('[data-cart-page]');
        if (b) b.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    changeLine(parseInt(btn.dataset.lineChange, 10), Math.max(0, parseInt(btn.dataset.quantity, 10)));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-input]');
    if (input) changeLine(parseInt(input.dataset.lineInput, 10), Math.max(0, parseInt(input.value, 10) || 0));

    var auto = e.target.closest('[data-autosubmit]');
    if (auto && auto.form) auto.form.submit();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || !window.fetch) return;
    if (cartType === 'page') return;
    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var errorEl = form.querySelector('[data-form-error]');
    var label = button ? button.innerHTML : '';
    if (button) { button.setAttribute('aria-disabled', 'true'); button.textContent = window.theme.strings.adding; }
    if (errorEl) errorEl.hidden = true;

    var data = new FormData(form);
    data.append('sections', cartSections().join(','));
    data.append('sections_url', window.location.pathname);

    fetch(window.theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (errorEl) { errorEl.textContent = res.description || res.message; errorEl.hidden = false; }
          return;
        }
        renderSections(res.sections);
        return refreshCount().then(function () { openLayer($('[data-cart-drawer]')); });
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (button) { button.removeAttribute('aria-disabled'); button.innerHTML = label; }
      });
  });

  /* ---------- Quantity steppers on product page ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10));
  });

  /* ---------- Variant picker ---------- */
  $$('[data-product]').forEach(function (product) {
    var section = product.closest('.shopify-section') || document;
    var jsonEl = section.querySelector('[data-product-json]');
    var picker = product.querySelector('[data-variant-picker]');
    var addBtn = product.querySelector('[data-add-button]');
    var stickyAdd = product.querySelector('[data-sticky-add]');

    // Mobile sticky add-to-cart: show once the main button is out of view.
    var sticky = product.querySelector('[data-sticky-buy]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var hidden = !entries[0].isIntersecting;
        sticky.classList.toggle('is-visible', hidden);
        sticky.setAttribute('aria-hidden', hidden ? 'false' : 'true');
        stickyAdd.tabIndex = hidden ? 0 : -1;
      }).observe(addBtn);
    }

    if (!jsonEl || !picker) return;

    var variants = JSON.parse(jsonEl.textContent);
    var idInput = product.querySelector('[data-variant-id]');
    var priceEl = product.querySelector('[data-price]');
    var form = addBtn && addBtn.form;
    var errorEl = product.querySelector('[data-form-error]');

    // Make shoppers choose a size rather than defaulting to the first one,
    // unless a specific variant was linked to (e.g. from the cart or Google).
    var sizeSet = picker.querySelector('fieldset[data-option-name="size"]');
    var sizeInputs = sizeSet ? $$('input', sizeSet) : [];
    if (sizeInputs.length > 1 && !new URLSearchParams(window.location.search).has('variant')) {
      sizeInputs.forEach(function (input) { input.checked = false; });
      var sizeLabel = sizeSet.querySelector('[data-option-label]');
      if (sizeLabel) sizeLabel.textContent = '';
      setNeedsSize(true);
    }

    function setNeedsSize(on) {
      product.classList.toggle('needs-size', on);
      if (!on) return;
      [addBtn, stickyAdd].forEach(function (btn) {
        if (btn) { btn.disabled = false; btn.textContent = window.theme.strings.selectSize; }
      });
    }

    if (form) {
      // Runs before the document-level add-to-cart handler.
      form.addEventListener('submit', function (e) {
        if (!product.classList.contains('needs-size')) return;
        e.preventDefault();
        e.stopPropagation();
        if (errorEl) { errorEl.textContent = window.theme.strings.selectSize; errorEl.hidden = false; }
        sizeSet.scrollIntoView({ behavior: 'smooth', block: 'center' });
        sizeInputs[0].focus({ preventScroll: true });
      });
    }
    var money = function (cents) {
      var fmt = window.theme.moneyFormat || '${{amount}}';
      var group = function (n, dec, sep, point) {
        var parts = (n / 100).toFixed(dec).split('.');
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (parts[1] ? point + parts[1] : '');
      };
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
        switch (key) {
          case 'amount_no_decimals': return group(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
          default: return group(cents, 2, ',', '.');
        }
      });
    };

    function selected() {
      return $$('fieldset', picker).map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function markAvailability(options) {
      // Grey out values that have no available variant given the other selections.
      $$('input[data-option-index]', picker).forEach(function (input) {
        var idx = parseInt(input.dataset.optionIndex, 10);
        var test = options.slice();
        test[idx] = input.value;
        var ok = variants.some(function (v) {
          return v.available && v.options.every(function (o, i) { return i === idx ? o === input.value : (i > idx ? true : o === test[i]); });
        });
        input.classList.toggle('is-unavailable', !ok);
      });
    }

    function update() {
      var options = selected();
      options.forEach(function (val, i) {
        var label = picker.querySelector('[data-option-label="' + i + '"]');
        if (label) label.textContent = val;
      });
      markAvailability(options);

      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      });

      if (options.indexOf(null) !== -1) { setNeedsSize(true); return; }
      setNeedsSize(false);
      if (errorEl) errorEl.hidden = true;

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = window.theme.strings.unavailable; }
        return;
      }

      idInput.value = variant.id;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
      }
      var stickyPrice = product.querySelector('[data-sticky-price]');
      if (stickyAdd) { stickyAdd.disabled = !variant.available; stickyAdd.textContent = addBtn ? addBtn.textContent : stickyAdd.textContent; }
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      var bnpl = product.querySelector('[data-bnpl-amount]');
      if (bnpl) bnpl.textContent = money(Math.floor(variant.price / 4));
      if (priceEl) {
        var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceEl.classList.toggle('price--sale', !!sale);
        priceEl.innerHTML = '<span class="price__current">' + money(variant.price) + '</span>' +
          (sale ? '<s class="price__compare">' + money(variant.compare_at_price) + '</s>' : '');
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      if (variant.featured_media) {
        var media = product.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        var gallery = product.querySelector('.gallery');
        if (media && gallery && media !== gallery.firstElementChild) {
          gallery.insertBefore(media, gallery.firstElementChild);
          if (window.innerWidth < 750) gallery.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }
    }

    picker.addEventListener('change', update);
    markAvailability(selected());
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        else { var s = el.closest('.shopify-section'); if (s) s.hidden = true; }
      });
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
    document.addEventListener('shopify:section:load', function (e) {
      $$('.reveal', e.target).forEach(function (el) { el.classList.add('is-visible'); });
    });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }
})();
